import { useState } from 'react';
import './RadioFilterPopup.scss';
export type RadioFilterPopupProps = {
	onFundTypeFilterChange: (value: string) => void;
	handleAnswered: () => Promise<void>;
	labels: string[];
	selectedFilter: string;
};

const RadioFilterPopup: React.FC<RadioFilterPopupProps> = ({
	onFundTypeFilterChange,
	handleAnswered,
	labels,
	selectedFilter,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const isDefault = (): boolean => {
		return selectedFilter === labels[0];
	};

	const handleFilterOpening = () => {
		setIsOpen((prev) => !prev);
	};

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const handleChange = (event) => {
		onFundTypeFilterChange(event.target.value);
	};

	const handleAjax = () => {
		handleAnswered();
		handleFilterOpening();
	};

	return (
		<>
			<div className="buttonContainer content row" id="buttonContainer">
				<button
					type="button"
					className={
						'row col-10 selector' +
						(!isDefault() && !isOpen ? ' selectedFundTypeBtn' : ' fundTypeBtn')
					}
					onClick={handleFilterOpening}
				>
					<div
						id="selectMaterial"
						className="selectMaterial col-12 justify-content-center"
						tabIndex={0}
						aria-label="Fund type filter"
						aria-expanded={isOpen}
						role="button"
					>
						<span className="fundTypeTitleMobile pr-1" id="materialTypeText">
							FUND TYPE
						</span>
						<i className="fa fa-sort-desc" />
					</div>
					{!isDefault() && !isOpen ? (
						<div
							id="selectedMaterial"
							className="selectMaterial col-12 justify-content-center"
							tabIndex={0}
							aria-label={'Selected fund type: ' + selectedFilter}
						>
							<span
								className="fundTypeTitleMobile"
								id="selectedMaterialTypeText"
							>
								{selectedFilter}
							</span>
						</div>
					) : (
						<></>
					)}
				</button>
			</div>
			{isOpen ? (
				<div className="tableContainer" id="filterDialogContainer">
					<div
						className="content row selectorDialog materialTypeDialog"
						id="materialTypeDialog"
					>
						<div className="Rtable col-12" id="materialTypeTable">
							{labels.map((label) => {
								const labelCased = label.replaceAll(' ', '');
								return (
									<div
										className="Rtable-row col-12"
										tabIndex={-1}
										role="option"
										key={labelCased}
										id={'dialog' + labelCased}
									>
										<div className="Rtable-cell">
											<input
												type="radio"
												name="radioGroup"
												onChange={handleChange}
												id={labelCased}
												value={label}
												checked={label === selectedFilter}
											/>
											<label htmlFor={labelCased}>{label}</label>
										</div>
										<div className="Rtable-cell Rtable-break"></div>
									</div>
								);
							})}
						</div>
						<hr className="horizontal-line" />
						<button
							type="button"
							className="col-12 Rtable-button"
							onClick={handleAjax}
							aria-labelledby="applyFilterLabel"
						>
							<div className="Rtable-cell Rtable-applyFilter">
								<span
									id="applyFilterLabel"
									className="applyFilterTableButton"
									tabIndex={-1}
								>
									Apply filter
								</span>
							</div>
						</button>
					</div>
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export default RadioFilterPopup;
